import { clearCache } from './cacheUtils';
import { dispatchSyncEvent } from './syncUtils';
import { invalidateCacheByType } from './swCacheUtils';
import { queryClient } from '../query/queryClient';

const queryInvalidationPrefixes = {
  branches: { prefixes: [['reference', 'branches']], refetchType: 'active' },
  doctors: { prefixes: [['reference', 'doctors']], refetchType: 'active' },
  salespersons: { prefixes: [['reference', 'salespersons']], refetchType: 'active' },
  users: { prefixes: [['reference', 'users']], refetchType: 'active' },
  patients: { prefixes: [['patients'], ['dashboard']], refetchType: 'none' },
  products: { prefixes: [['products'], ['inventory']], refetchType: 'none' },
  invoices: { prefixes: [['invoices'], ['dashboard']], refetchType: 'none' },
  audiometry: { prefixes: [['audiometry']], refetchType: 'none' },
  services: { prefixes: [['services'], ['dashboard']], refetchType: 'none' },
};

export const invalidateCaches = async (keys = []) => {
  for (const key of keys) {
    if (!key) continue;
    clearCache(key);
    dispatchSyncEvent(key, true);

    // Invalidate Service Worker cache
    try {
      await invalidateCacheByType(key);
    } catch (error) {
      console.warn(`Failed to invalidate SW cache for ${key}:`, error);
    }

    // Invalidate TanStack Query cache
    const config = queryInvalidationPrefixes[key] || { prefixes: [], refetchType: 'none' };
    config.prefixes.forEach((prefix) => {
      queryClient.invalidateQueries({ queryKey: prefix, refetchType: config.refetchType });
    });
  }
};
